import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { type Conversation } from "shared/apiClient";
import { AnalysisReportEvents } from "shared/types";
import { EventTypes } from "@/types/events";

import { AnalysisTabs, AnalysisTabItems } from "./AnalysisTabs";

export interface AnalysisSidebarContainerProps {
  conversation: Conversation | undefined | null;
}

export function AnalysisTabsContainer({ conversation }: AnalysisSidebarContainerProps) {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedMenuItem = (searchParams.get("selectedMenuItem") ||
    "") as AnalysisTabItems;

  useEffect(() => {
    const scrollToTopEvent = new CustomEvent(EventTypes.ScrollToTop);
    document.dispatchEvent(scrollToTopEvent);
  }, [selectedMenuItem]);

  useEffect(() => {
    if (!selectedMenuItem) {
      setSearchParams((prev) => {
        prev.set("selectedMenuItem", AnalysisTabItems.PERMIT_REQUIREMENTS);
        return prev;
      });
    }
  }, [selectedMenuItem, setSearchParams]);

  useEffect(() => {
    const handleShowPermitRequirementsEvent = () => {
      setSearchParams((prev) => {
        prev.set("selectedMenuItem", AnalysisTabItems.PERMIT_REQUIREMENTS);
        return prev;
      });
    };

    document.addEventListener(
      AnalysisReportEvents.SHOW_PERMIT_REQUIREMENTS,
      handleShowPermitRequirementsEvent,
    );

    return () => {
      document.removeEventListener(
        AnalysisReportEvents.SHOW_PERMIT_REQUIREMENTS,
        handleShowPermitRequirementsEvent,
      );
    };
  }, [setSearchParams]);

  const handleClickMenuItem = (menuItem: AnalysisTabItems) => {
    setSearchParams((prev) => {
      prev.set("selectedMenuItem", menuItem);
      return prev;
    });
  };

  return (
    <AnalysisTabs
      activeTab={selectedMenuItem}
      conversation={conversation}
      onChange={() => {
        const reRenderPortalsEvent = new CustomEvent(
          EventTypes.ReRenderPortals,
        );
        document.dispatchEvent(reRenderPortalsEvent);
      }}
      onSelect={handleClickMenuItem}
    />
  );
}
